// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7k-3";
export var contentContainer = "_7k-0";
export var editorContainer = "_7k-1";
export var quillInputForm = "_7k-2";
export var zoneDivider = "_7k-4";